import { Box, TextField } from '@atgfr8/atg-ui-tailwind';
import { JSX } from 'solid-js';

import { MAX_RADIUS_MILES } from './helpers';

type PropsT = {
  label: string;
  value: number;
  dataTestId: string;
  onChange: (miles: number) => void;
};

const clampRadius = (miles: number) =>
  Math.min(MAX_RADIUS_MILES, Math.max(0, Math.trunc(miles) || 0));

export const RadiusSlider = (props: PropsT) => {
  const percent = () => (props.value / MAX_RADIUS_MILES) * 100;

  const handleInput: JSX.EventHandler<HTMLInputElement, InputEvent> = (e) => {
    props.onChange(Number(e.currentTarget.value));
  };

  return (
    <Box
      class="w-full select-none mt-3 flex items-center gap-3"
      data-testid={props.dataTestId}
    >
      <div
        class="group relative flex flex-1 items-center h-6"
        style={{ '--lane-history-radius-pct': `${percent()}%` }}
      >
        <div class="absolute inset-x-0 h-1 rounded-full bg-slate-200" />
        <div class="absolute left-0 h-1 w-[var(--lane-history-radius-pct)] rounded-full bg-armstrong-blue pointer-events-none" />
        <div class="absolute left-[var(--lane-history-radius-pct)] w-[20px] h-[20px] rounded-full bg-armstrong-blue shadow-[0_1px_5px_rgba(0,0,0,0.22)] pointer-events-none -translate-x-1/2 group-has-[input:focus-visible]:ring-4 group-has-[input:focus-visible]:ring-armstrong-blue/30" />
        <input
          type="range"
          class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          min={0}
          max={MAX_RADIUS_MILES}
          step={1}
          value={props.value}
          onInput={handleInput}
          aria-label={props.label}
          aria-valuenow={props.value}
          aria-valuetext={`${props.value} miles`}
          data-testid={`${props.dataTestId}-input`}
        />
      </div>
      <TextField
        type="number"
        label="Radius"
        size="md"
        maxLength={3}
        value={String(props.value)}
        onChange={(value: string) => props.onChange(clampRadius(Number(value)))}
        class="max-w-[80px]!"
        dataTestId={`${props.dataTestId}-textInput`}
      />
    </Box>
  );
};
